import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-tokens.css';
import App from './App';
import './styles/content-theme.css';
import { initializeTheme } from './theme/themePreference';
import reportWebVitals from './reportWebVitals';

initializeTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 성능 측정 (선택사항)
reportWebVitals();
